import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { printAppInfo } from '@shared/environment/printAppInfo';
import { LoginAppModule } from './app/login-app.module';
import { environment } from './environments/environment';

printAppInfo();
if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(LoginAppModule)
    .catch((err) => console.error(err));
